import React, { useState } from 'react';
import { useWizard } from '../../../../components/wizard/WizardContext';
import BulbIcon from "../../../../assets/img/svg/svgComponents/BulbIcon";
import CrossIcon from "../../../../assets/img/svg/svgComponents/CrossIcon";
import styles from "../../refundStyles.module.scss";

const Tips = ({ tipsArr = [] }) => {
    return (
        <div className='d-flex flex-column justify-content-between' style={{ gap: '0.5rem' }}>
            {tipsArr?.map((tip, idx) =>
                <div key={tip}>
                    <span className={styles['idx']}>{idx + 1}</span>
                    <span className={styles['tip']}>{tip}</span>
                </div>
            )}
        </div>
    )
}

const RefundTipsCard = () => {

    const { values } = useWizard();
    const { refundType } = values;

    const tips = refundType?.tips;
    const [isShow, setIsShow] = useState(Boolean(tips));


    if (!isShow) return null;

    return (
        <div className={`d-flex flex-column ${styles['tips-card']} w-25`}>
            <div className='d-flex justify-content-between'>
                <BulbIcon />
                <span className="cursor" onClick={() => setIsShow(false)}><CrossIcon color={"#0699A3"} /></span>
            </div>

            <div className={`${styles['heading']}`}>Tips</div>

            {
                Array.isArray(tips)
                    ? <Tips tipsArr={tips} />
                    : Object.keys(tips)?.map(subHeading =>
                        <div key={subHeading}>
                            <div className='mb-1'>{subHeading}</div>
                            <Tips tipsArr={tips[subHeading]} />
                        </div>
                    )
            }




        </div>
    );
}

export default RefundTipsCard;